import { prop } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class ClientSubtype extends Resource {
    public override type = 'clientSubtypes';


    @prop()
    public name!: string;


}